export default {
  baseline: '1em',
  small: '0.9em',
  xs: '0.8em'
};
